import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';

import CustomerNumberCard from './CustomerNumberCard';

const useStyles = makeStyles(() => ({
  container: {
    margin: 0,
    maxWidth: '100%',
  },
}));

const ContractTab: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={2} direction="row" className={classes.container}>
        <Grid item xs={12}>
          <CustomerNumberCard />
        </Grid>
      </Grid>
    </>
  );
};

export { ContractTab };
